import {
    ModuleWithProviders,
    NgModule,
} from '@angular/core';

import { PageMetadataRegistry } from './page-metadata-registry';

@NgModule()
export class PageMetadataModule {
    public static forRoot(): ModuleWithProviders {
        return {
            ngModule: PageMetadataModule,
            providers: [PageMetadataRegistry],
        };
    }
}
